import React from "react";
import { AppError, IErrorContext } from ".";

export interface IErrorContextProps {
    children: React.ReactNode;
}

export interface IErrorContextState {
    Error?: AppError;
}

export const ErrorContext = React.createContext<IErrorContext>({
    Error: undefined,
    SetError: (error: AppError | undefined) => Promise.resolve(),
});

export const ErrorContextProvider = (({ children }: IErrorContextProps) => {
    const [error, setError] = React.useState<Error>();

    const setErrorState = React.useCallback((appError: AppError | undefined) => {
        setError(appError);
    }, []);

    return (
        <ErrorContext.Provider value={{ Error: error, SetError: setErrorState }}>
            {children}
        </ErrorContext.Provider>
    );
});
